import Vue from 'vue'
import Tinybox from 'vue-tinybox'

export default Vue.component('Tinybox', Tinybox)
